import React, { PureComponent } from "react";
import Chart from "chart.js";

let thisBarChart;

export default class SentimentBarChart extends PureComponent {
  chartRef = React.createRef();

  componentDidMount() {
    this.buildChart();
  }
  componentDidUpdate() {
    this.buildChart();
  }

  buildChart = () => {
    const myChartRef = this.chartRef.current.getContext("2d");

    let blue = myChartRef.createLinearGradient(0, 0, 0, 200);
    blue.addColorStop(0, "#bac8ff");
    blue.addColorStop(1, "#dbe4ff");

    let red = myChartRef.createLinearGradient(0, 0, 0, 200);
    red.addColorStop(0, "#ffa8a8");
    red.addColorStop(1, "#ffe3e3");

    if (typeof thisBarChart !== "undefined") thisBarChart.destroy();

    thisBarChart = new Chart(myChartRef, {
      type: "bar",
      data: {
        labels: this.props.labels,
        datasets: [
          {
            label: "Negative",
            borderColor: "#ffa8a8",
            lineTension: 0,
            backgroundColor: "#ffa8a8",
            pointBackgroundColor: "#ffa8a8",
            pointBorderColor: "#ffa8a8",
            pointHoverBackgroundColor: "#ffa8a8",
            borderWidth: 2,
            pointRadius: 3,
            pointHoverRadius: 0,
            pointHighlightFill: "#fff",
            pointHighlightStroke: "#ffa8a8",
            data:
              this.props.sentiment === "positive sentiment" ||
              this.props.sentiment === "neutral sentiment"
                ? null
                : this.props.negativeSentimentData,
          },
          {
            label: "Positive",
            borderColor: "#91a7ff",
            lineTension: 0,
            backgroundColor: "#91a7ff",
            pointBackgroundColor: "#91a7ff",
            pointBorderColor: "#91a7ff",
            pointHoverBackgroundColor: "#91a7ff",
            borderWidth: 2,
            pointRadius: 3,
            pointHoverRadius: 0,
            pointHighlightFill: "#fff",
            pointHighlightStroke: "#91a7ff",
            data:
              this.props.sentiment === "negative sentiment" ||
              this.props.sentiment === "neutral sentiment"
                ? null
                : this.props.positiveSentimentData,
          },
          {
            label: "Neutral",
            borderColor: "#e9ecef",
            lineTension: 0,
            backgroundColor: "#e9ecef",
            pointBackgroundColor: "#e9ecef",
            pointBorderColor: "#e9ecef",
            pointHoverBackgroundColor: "#e9ecef",
            borderWidth: 0,
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHighlightFill: "#fff",
            pointHighlightStroke: "#e9ecef",
            data:
              this.props.sentiment === "positive sentiment" ||
              this.props.sentiment === "negative sentiment"
                ? null
                : this.props.neutralSentimentData,
          },
        ],
      },
      options: {
        tooltips: {
          backgroundColor: "#212529",
          mode: "index",
          intersect: false,
          titleFontFamily: "sans-serif",
          titleFontStyle: "500",
          bodyFontFamily: "sans-serif",
        },
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              stacked: true,
              display: true,
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 3,
                padding: 8,
                min: 0,
                max: this.max, // Your absolute max value
                callback: function (value) {
                  return ((value / this.max) * 100).toFixed(0) + "%"; // convert it to percentage
                },
              },
              gridLines: {
                drawBorder: false,
                color: "#dee2e6",
                borderDash: [8, 8],
                borderWidth: 1,
                lineWidth: 1,
                zeroLineColor: "transparent",
              },
            },
          ],
          xAxes: [
            {
              stacked: true,
              ticks: {
                fontFamily: "proxima nova",
              },
              gridLines: {
                drawBorder: false,
                display: false,
                color: "#dee2e6",
                borderDash: [8, 8],
                borderWidth: 1,
                lineWidth: 1,
              },
            },
          ],
        },
      },
    });
  };

  render() {
    return (
      <div>
        <div className="chart-bg-2">
          <div className="html-embed sentiment-chart w-embed">
            <canvas
              id="sentimentArea"
              width="940"
              height="180"
              ref={this.chartRef}
            ></canvas>
          </div>
        </div>
      </div>
    );
  }
}
